import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
export class LiveMonitorTheme2 extends Component {
  render() {
    const rowData = [
      {"id" : "id","name" : "name","state" : "state","time" : "time","contactInfo" : "contactInfo","actions" : "actions"},
      {"id" : "id","name" : "name","state" : "state","time" : "time","contactInfo" : "contactInfo","actions" : "actions"},
      {"id" : "id","name" : "name","state" : "state","time" : "time","contactInfo" : "contactInfo","actions" : "actions"},
      {"id" : "id","name" : "name","state" : "state","time" : "time","contactInfo" : "contactInfo","actions" : "actions"},
    ];

      const defaultColDef = {
              resizable: true,
              sortable: true
            };
  
      const columnDefs = [
              { field: 'id',
                headerName: '#'  ,
                width: "15%",
                minWidth: 200,
                flex: 1,
                maxWidth: 350
              },
              { field: 'name',
                headerName: 'Name',
                width: "17%",
                minWidth: 200,
                flex: 1,
                maxWidth: 350
              },
              { field: 'state',
                headerName: 'State',
                width: "17%",
                minWidth: 200,
                flex: 1,
                maxWidth: 350
              },
              { field: 'time',
                headerName: 'Time',
                width: "17%",
                minWidth: 200,
                flex: 1,
                maxWidth: 350,
                sortable: true
              },
              { field: 'contactInfo',
                headerName: 'Contact Info',
                width: "17%",
                minWidth: 200,
                flex: 1,
                maxWidth: 350
              },
              { field: 'actions',
                headerName: 'Actions',
                width: "17%",
                minWidth: 200,
                flex: 1,
                maxWidth: 350
              },
            ]
    return (
      <div className="ag-theme-alpine" style={{height: 400,margin:"0px 18px 22px 18px"}}>
           <AgGridReact
              style={{ width: '100%', height: '100%;' }}
              className="ag-theme-alpine"
              animateRows="true"
              defaultColDef={defaultColDef}
              enableRangeSelection="true"
              rowData={rowData}
              rowSelection="multiple"
              suppressRowClickSelection="true"
              columnDefs={columnDefs}>
           </AgGridReact>
       </div>
    )
  }
}
LiveMonitorTheme2.contextTypes = {
  __: PropTypes.func
};

export default LiveMonitorTheme2;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/LiveMonitorTheme2.js